module.exports = __webpack_public_path__ + "static/media/TRIPLANAR U2SE TONEARM.15a1d606.png";